import React, { useState } from "react";
import "./index.css";
import callImg from "../../assets/images/home/callImg.webp";
import emailImg from "../../assets/images/home/email.webp";

export const ContactSection = () => {
  const [selectedGender, setSelectedGender] = useState("Select Gender");
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (value) => {
    setSelectedGender(value);
    setIsOpen(false); // close after selecting
  };

  return (
    <div className="contactContainer">
      <div className="container">
        <div className="contactGrid">
          <div className="contactLeft">
            <div>Let’s Stay Connected</div>
            <div>
              All services are available fully online, including inquiries and
              support. In-person sessions are by appointment only.
            </div>
            <div>
              <ul className="contactList">
                <li>
                  <div>
                    <img src={callImg} />
                    {/* India: +91 9032986966 */}
                    India: +91-6366636157
                  </div>
                </li>
                {/* <li>
                  <div>
                    <img src={callImg} />
                    Dubai: +971 581725302
                  </div>
                </li> */}
                <li>
                  {/* <div>
                    Email: 
                  </div> */}
                   <div>
                    <img src={emailImg} />
                    Customer: hey@listenaura.com
                  </div>
                   <div>
                    <img src={emailImg} />
                    Business collaborations: connect@listenaura.com
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="contactRight">
            <div className="formHeading">Get in Touch</div>
            <div className="formPara">We’re just a message away</div>

            <form>
              <div className="contactInput">
                <label>Full Name</label>
                <input type="text" placeholder="Full Name" />
              </div>
              <div className="contactInput">
                <label>Email Address</label>
                <input type="email" placeholder="Email Address" />
              </div>
              <div className="contactInput">
                <label>I’m a</label>
                {/* <select
                  className="form-select form-select-md mb-3"
                  aria-label=".form-select-md"
                >
                  <option selected>Open this select menu</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                  <option value="3">Prefer not to say</option> 
                </select> */}
                <div className="dropdown w-100 dropClassColor">
                  <button
                    className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    {selectedGender}
                  </button>

                  {isOpen && (
                    <ul className="dropdown-menu show w-100">
                      <li>
                        <div className="form-check dropdown-item">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="male"
                            value="Male"
                            checked={selectedGender === "Male"}
                            onChange={() => handleSelect("Male")}
                          />
                          <label className="form-check-label" htmlFor="male">
                            Male
                          </label>
                        </div>
                      </li>
                      <li>
                        <div className="form-check dropdown-item">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="female"
                            value="Female"
                            checked={selectedGender === "Female"}
                            onChange={() => handleSelect("Female")}
                          />
                          <label className="form-check-label" htmlFor="female">
                            Female
                          </label>
                        </div>
                      </li>
                      <li>
                        <div className="form-check dropdown-item">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="preferNotSay"
                            value="Prefer not to say"
                            checked={selectedGender === "Prefer not to say"}
                            onChange={() => handleSelect("Prefer not to say")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="preferNotSay"
                          >
                            Prefer not to say
                          </label>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
              <div className="contactInput">
                <label>Message</label>
                <textarea placeholder="Message" rows={4}></textarea>
              </div>
              <div className="btnSend">
                <button type="button">Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
